<template>
  <v-footer class="footer-container" height="65">
    <v-container class="pb-2">
      <v-row>
        <v-col cols="12" sm="4" class="footer-left">
          ©{{ currentYear }} 3xLOGIC, Inc. All Rights Reserved.
        </v-col>
        <v-col
          cols="12"
          sm="8"
          :class="[
            'footer-right',
            { 'text-right': $vuetify.breakpoint.width > 600 },
          ]"
        >
          <a
            class="link mr-2"
            @click="openTermsDialog"
            data-testid="footer-open-terms-dialog"
          >
            {{ $t('terms.termsOfUse') }}
          </a>
          |
          <a
            class="link ml-2 mr-2"
            href="https://www.securitas.com/en/about-us/securitas-technology-and-healthcare-global-privacy-policy"
            rel="noopener"
            target="_blank"
            @click="privacyPolicyClick"
            data-testid="footer-privacy-policy"
          >
            {{ $t('global.securitasPrivacyPolicy') }}</a
          >
          |
          <a
            class="link ml-2 mr-2"
            href="https://vigilcloud.3xlogic.com/vigil-cloud-privacy-policy"
            rel="noopener"
            target="_blank"
            @click="privacyPolicyClick"
            data-testid="footer-privacy-policy"
          >
            {{ $t('global.privacyPolicy') }}
          </a>
          |
          <a
            class="link ml-2"
            @click="openBrowserCompatDialog"
            data-testid="footer-browser-compat"
          >
            {{ $t('global.browserCompatibility') }}
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import {
  BROWSER_COMPAT_CLICK,
  PRIVACY_POLICY_CLICK,
} from '@/constants/mixpanelEvents'
export default defineComponent({
  methods: {
    openTermsDialog() {
      this.$emit('openTermsDialog')
    },
    openBrowserCompatDialog() {
      this.$mixpanelUserTrack(BROWSER_COMPAT_CLICK)
      this.$emit('openBrowserCompatDialog')
    },
    privacyPolicyClick() {
      this.$mixpanelUserTrack(PRIVACY_POLICY_CLICK)
    },
  },
  computed: {
    currentYear() {
      let d = new Date()
      return d.getFullYear()
    },
  },
})
</script>
<style lang="scss">
.footer-container {
  font-family: 'IBM Plex Sans';
  font-size: 14px;
  opacity: 0.7;
  letter-spacing: 0;
}
.footer-left {
  color: #ffffff;
  padding: 10px;
}
.footer-right {
  color: #ffffff;
  padding: 10px;
  a {
    text-decoration: none;
  }
  .link {
    color: #0091ff;
    &:hover {
      color: white;
    }
  }
}
</style>
